import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable, throwError } from 'rxjs'
import { tap } from 'rxjs/operators'
import { Message } from '../models/message'
import { MessagingService } from '../services/messaging.service'
import { AuthStore } from '../stores/auth.store'
import { EnvUtilities } from '../utilities/env-utilities'

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private messaging = inject(MessagingService)
  private authStore = inject(AuthStore)

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request.clone()).pipe(
      tap({
        next: (response) => {
          return response
        },
        error: (error: HttpErrorResponse) => {
          const showAuthMessages =
            [
              EnvUtilities.serviceUrl('auth/me'),
              EnvUtilities.serviceUrl('auth/refresh'),
            ].indexOf(request.url) < 0
          if (error.status === 401 && showAuthMessages) {
            this.messaging.broadcast(
              new Message(
                'http-unauthorised',
                'Unauthorised',
                'You need to log in to access this resource',
                Message.Bad,
                Message.Medium
              )
            )
            this.authStore.reset()
          } else if (error.status === 404) {
            this.messaging.broadcast(
              new Message(
                'http-not-found',
                'Not Found',
                'The resource you require could not be found',
                Message.Bad,
                Message.Medium
              )
            )
          } else if (error.status === 500) {
            this.messaging.broadcast(
              new Message(
                'http-server-error',
                'Server Error',
                'There was an error acquiring this resource from the server',
                Message.Bad,
                Message.Medium
              )
            )
          } else if (error.status === 503) {
            this.messaging.broadcast(
              new Message(
                'http-service-unavailable',
                'Service Unavailable',
                'The server is currently unavailable',
                Message.Bad,
                Message.Medium
              )
            )
          }
          return throwError(() => error)
        },
      })
    )
  }
}
